import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChatFloatPatientService {

  // Private BehaviorSubject to store the patient chat data
  private chatArraySubject = new BehaviorSubject<number[]>([]);

  // Public observable for components to subscribe to changes
  chatArray$: Observable<number[]> = this.chatArraySubject.asObservable();

  constructor() { }

  // Get current value
  getChats(): number[] {
    return this.chatArraySubject.getValue();
  }

  // Replace the whole chat array
  setChats(newChats: number[]): void {
    this.chatArraySubject.next(newChats);
  }

  // Add a chat message
  addChat(chat: number): void {
    const updatedChats = [...this.getChats(), chat];
    this.chatArraySubject.next(updatedChats);
  }

  // Remove a chat message by index
  removeChat(index: number): void {
    const currentChats = this.getChats();
    this.setChats(currentChats.filter(x => x != index));
    // if (index >= 0 && index < currentChats.length) {
    //   currentChats.splice(index, 1);
    //   this.chatArraySubject.next([...currentChats]);
    // }
  }

  // Clear all chats
  clearChats(): void {
    this.chatArraySubject.next([]);
  }
}
